import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'PC_home',
      components: {
        default: r => require.ensure([], () => r(require('pc/pages/index')), 'asyn-app'),
        aside: r => require.ensure([], () => r(require('pc/components/aside')), 'asyn-app'),
        header: r => require.ensure([], () => r(require('pc/components/header')), 'asyn-app'),
        footer: r => require.ensure([], () => r(require('pc/components/footer')), 'asyn-app')
      }
    }
  ]
})
